// src/components/Spinner.jsx
import React from 'react';
import './Spinner.css';

const Spinner = ({
  size = 120,
  pulseScale = 1.1,
  pulseDuration = 0.6,
  textCycleDuration = 2,
  spinnerText = 'Cargando',
  textSize,
  textOffsetX,
  textOffsetY,
  textColor = '#000',
  showEllipses = true,        // Controla los puntos suspensivos
  containerOffsetY = '0',     // ← sube/ baja el spinner de su posición inicial
}) => {
  const defaultTextSize = `${size * 0.12}px`;
  const defaultOffsetX = `-50%`;
  const defaultOffsetY = `-40%`;

  const cssVars = {
    '--spinner-size':        `${size}px`,
    '--pulse-scale':         pulseScale,
    '--pulse-duration':      `${pulseDuration}s`,
    '--text-cycle-duration': `${textCycleDuration}s`,
    '--text-size':           textSize || defaultTextSize,
    '--text-offset-x':       textOffsetX || defaultOffsetX,
    '--text-offset-y':       textOffsetY || defaultOffsetY,
    '--text-color':          textColor,
    '--container-offset-y':   containerOffsetY,
  };

  // Secuencia de puntos
  const dots = ['', '.', '..', '...'];

  return (
    <div className="petludos-spinner" style={cssVars}>
      <svg
        viewBox="-9 -66 34.133333 34.133333"
        xmlns="http://www.w3.org/2000/svg"
        className="paw-svg"
      >
        {/* Dedos */}
        <g className="toe toe1">
        <path
          d="m 62.726241,18.723361 c -0.664813,-0.0053 -1.213193,0.206926 -1.213193,0.206926 0,0 -1.073766,0.282965 -2.005853,1.545412 -0.932084,1.262447 -0.790517,3.067806 -0.790517,3.067806 0,0 0.04737,1.297806 0.979505,2.24169 0.932093,0.943883 1.651691,0.920334 1.651691,0.920334 1.262456,0.117994 1.982025,-0.318555 1.982025,-0.318555 0,0 1.073891,-0.625306 1.451453,-1.274231 0.377558,-0.64892 0.696105,-1.026727 0.802297,-2.230183 0.106169,-1.203452 -0.247899,-2.076524 -0.247899,-2.076524 0,0 -0.34223,-1.073665 -1.380505,-1.746183 -0.389356,-0.252195 -0.830102,-0.333384 -1.229004,-0.336492 z"
          transform="translate(-45.321778,-76.670545)"
        />
      </g>
      <g className="toe toe2">
        <path
          d="m 54.587191,16.65808 c -0.04635,0.0015 -0.09368,0.0027 -0.141603,0.0068 -0.766914,0.05899 -1.392029,0.389499 -1.392029,0.389499 0,0 -0.944081,0.601646 -1.309836,1.474739 -0.365758,0.873095 -0.306605,0.755156 -0.412791,1.876017 -0.106192,1.120864 0.578172,2.383345 0.766948,2.678304 0.188775,0.294971 1.026355,1.533627 2.135418,1.698808 0.967477,0.07081 1.43941,-0.129566 1.43941,-0.129566 0,0 0.943916,-0.31874 1.569237,-1.003058 0.625326,-0.68432 0.73163,-1.569147 0.719833,-2.100085 -0.01185,-0.530935 0.03534,-0.684351 -0.306778,-2.041181 -0.342161,-1.356809 -1.840665,-2.536628 -1.852458,-2.560227 -0.01111,-0.0221 -0.519878,-0.303437 -1.215351,-0.289915 z"
          transform="translate(-45.321778,-76.670545)"
        />
      </g>
      <g className="toe toe3">
        <path
          d="m 47.286302,20.300893 c -0.377825,-0.0066 -0.931445,0.06431 -1.488932,0.422697 -0.991076,0.637117 -1.286011,1.356682 -1.286011,1.356682 0,0 -0.424867,0.849698 -0.247891,1.946962 0.176982,1.097266 0.88503,1.87577 0.873231,1.863971 -0.01185,-0.01186 1.014513,1.687219 2.949481,1.887792 1.934963,0.200578 2.701882,-1.026369 2.690084,-1.014568 -0.01186,0.01185 0.483871,-0.507409 0.554668,-1.227117 0.02361,-1.132663 -0.247887,-2.100082 -0.247887,-2.100082 0,0 -0.318391,-1.085523 -1.368468,-2.029412 -1.05007,-0.94388 -1.946957,-1.049905 -1.946957,-1.049905 0,0 -0.187452,-0.05194 -0.481318,-0.05699 z"
          transform="translate(-45.321778,-76.670545)"
        />
      </g>
      <g className="toe toe4">
        <path
          d="m 44.423017,27.854758 c -0.476928,0.005 -1.005008,0.08053 -1.575392,0.266357 0,0 -1.831993,0.566213 -1.958469,1.946962 -0.141586,1.545618 0.176895,1.911194 0.365673,2.32414 0.354337,0.775129 1.321618,1.427622 1.321618,1.427622 0,0 1.191679,0.755143 2.206354,0.766957 1.014676,0.01192 1.026393,-0.05879 1.793304,-0.259396 0.766906,-0.200573 1.533631,-1.215342 1.533631,-1.215342 0,0 0.566406,-1.274194 0.271445,-2.406864 -0.294968,-1.132664 -1.203296,-1.982296 -1.203296,-1.982296 0,0 -1.051543,-0.885693 -2.754868,-0.86814 z"
          transform="translate(-45.321778,-76.670545)"
        />
      </g>
        {/* Almohadilla (vacía, sólo la forma) */}
        <g className="pad">
        <path
          d="m 56.964343,26.478262 c -0.09631,-0.0016 -0.196645,-8e-6 -0.300626,0.0027 -1.663604,0.04717 -1.875773,0.08268 -3.291601,0.731614 -1.415828,0.648923 -1.573141,1.021134 -2.159241,1.734412 -0.560648,0.682303 -1.129562,0.982149 -1.227122,2.347966 -0.106189,1.486619 -0.08651,1.887527 0.224332,3.102867 0.241502,0.944228 0.613555,1.899661 1.25068,2.642977 0.637122,0.743314 0.530716,0.707927 1.238632,1.262458 0.70791,0.554531 1.261572,0.504911 1.876026,0.342111 0.680013,-0.18017 1.616351,-1.356953 1.616351,-1.356953 0,0 0.784624,-0.802299 0.778722,-0.796395 -0.0059,0.0062 0.548605,-0.643031 1.445295,-0.784623 0.896696,-0.141576 2.200473,-0.123671 2.200473,-0.123671 0,0 0.967586,-0.08866 1.522117,-0.696281 0.554539,-0.607623 0.648897,-1.398181 0.648897,-1.398181 0,0 0.200618,-1.592756 -0.342108,-2.725419 -0.542737,-1.132665 -0.743275,-1.474773 -1.451193,-2.40686 -0.707913,-0.932093 -1.994064,-1.451186 -1.994064,-1.451186 0,0 -0.590925,-0.414815 -2.03557,-0.427781 z"
          transform="translate(-45.321778,-76.670545)"
        />
      </g>
    </svg>

      <div className={`spinner-text${showEllipses ? '' : ' static'}`}>
        {showEllipses
          ? dots.map((d, i) => (
              <span key={i}>
                {spinnerText}{d}
              </span>
            ))
          : <span>{spinnerText}</span>
        }
      </div>
    </div>
  );
};

export default Spinner;
